import React from "react";
import "../../../../css/pages/ca_pages/models/dashboard/ClientSnapshot.css";

const clients = [
    {
        id: 1,
        name: "ABC Pvt Ltd",
        businesses: 3,
        invoices: 5,
        documents: 2,
        status: "Needs Attention",
    },
    {
        id: 2,
        name: "XYZ Industries",
        businesses: 1,
        invoices: 0,
        documents: 0,
        status: "Healthy",
    },
    {
        id: 3,
        name: "Tech Solutions",
        businesses: 5,
        invoices: 12,
        documents: 1,
        status: "Busy",
    },
];

const ClientSnapshot = () => {
    return (
        <div className="caDashPro__snapshotCard">

            <div className="caDashPro__snapshotHeader">
                <h3>Client Snapshot</h3>

                <span>{clients.length} Clients</span>
            </div>

            <div className="caDashPro__snapshotList">

                {clients.map((client) => (

                    <div
                        className="caDashPro__snapshotItem"
                        key={client.id}
                    >

                        <div className="caDashPro__snapshotTop">

                            <div>

                                <h4>{client.name}</h4>

                                <p>
                                    {client.businesses} Businesses
                                </p>

                            </div>

                            <button>
                                Open →
                            </button>

                        </div>

                        <div className="caDashPro__snapshotStats">

                            <div>
                                <span>Invoices</span>
                                <strong>{client.invoices}</strong>
                            </div>

                            <div>
                                <span>Documents</span>
                                <strong>{client.documents}</strong>
                            </div>

                            <div>
                                <span>Status</span>

                                <strong
                                    className={`status ${client.status
                                        .replace(/\s/g, "")
                                        .toLowerCase()}`}
                                >
                                    {client.status}
                                </strong>

                            </div>

                        </div>

                    </div>

                ))}

            </div>

        </div>
    );
};

export default ClientSnapshot;
